<template>
    <section class="central-background">
        <LevelTwo :router="router" />
        <main class="content-layout card px-0 list-section mt-3 position-relative">
            <section class="w-100 h-100 py-2">
                <section class="mt-2">
                    <router-view />
                </section>
            </section>
        </main>
    </section>
</template>

<script lang="ts" src="./CentralIntake.ts"></script>
<style src="./CentralIntake.scss"></style>
